import { createContext } from 'react';

export type ToastVariant = 'success' | 'warning' | 'danger' | 'info';

export interface ToastContextValue {
  show: (message: string, options?: { variant?: ToastVariant; durationMs?: number }) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
